





















import {defineComponent} from '@vue/composition-api';
import {Category, Exercise} from '@/helpers/types'
import {useStore} from '@/utils/use-store'

export default defineComponent({
  name: 'QuestionsTable',

  props: {
    items: {
      type: Array,
      require: true
    },
    categories: {
      type: Array,
      require: true
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },

  setup(props) {
    const headers = [
      {
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Questions Type',
        value: 'type'
      },
      {
        text: 'Summary',
        value: 'summary'
      },
      {
        text: 'Instructions',
        value: 'instructions'
      },
      {
        text: 'Category',
        value: 'practice'
      }
    ];

    const store = useStore();
    const { exerciseTypes } = store.state;

    /**
     * Get category by id
     * @param {Category[]} categories
     * @param {Exercise} item
     * @return {Category} category
     * */
    function getCategory(categories: Category[], item: Exercise): Category {
      const category = categories.find(category => category.id === item.practice?.category.id);
      return category || { description: '', name: '', execution_time: null };
    }

    /**
     * Get type by value
     * @param {string} value
     * @return {string} name
     * */
    function getType(value: string): string {
      return exerciseTypes.find((item: { value: string; }) => item.value === value)?.name || '';
    }

    return {
      headers,
      getCategory,
      getType
    };
  }
});
